<template>
  <div class="main-box">
    <xr-table ref="xrTable" :configure="configure"></xr-table>
    <!-- 新增页面 -->
    <page-add ref="pageAdd" v-if="isPageAddShow" @callBackMethod="refreshTable"></page-add>
    <!-- 修改页面 -->
    <page-edit ref="pageEdit" v-if="isPageEditShow" @callBackMethod="refreshTable"></page-edit>
  </div>
</template>
<script>
  import PageAdd from './add.vue'
  import PageEdit from './edit'
  export default {
    name: "medicalTeamList",
    data() {
      return {
        layoutConfigure:{
          westWidth: '880px',
        },
        isPageAddShow: false,                //是否显示新增页面
        isPageEditShow: false,               //是否显示修改页面
        pageId: '',
        configure: {
          url: '',
          listParam: {},
          isShowSearch: false,
          defaultNoLoadData: true,
          that: this,
          columns: [],
          toolbar: []
        },

      }
    },
    created() {
      let id = this.$route.params.id;
      this.pageId = id;
      this.getPageInfo();
    },
    components: {
      PageAdd,
      PageEdit
    },
    methods: {
      //初始化页面信息
      getPageInfo(){
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method': 'tGenerateNormalTable_getPageInfo',
            pageId: this.pageId
          }
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          if(!!response.data && !!response.data.configure){
            this.configure =  Object.assign({}, response.data.configure);
            this.configure['that'] = this;
            //工具栏
            let toolbar = this.configure.toolbar;
            for(let i = 0; i < toolbar.length; i ++){
              toolbar[i]['that'] = this;
              if(toolbar[i]['toolbarType'] == 'save'){
                toolbar[i]['handler'] = function () {
                  this.that.handleAddOpenDialog(toolbar[i]['relatePageId']);
                };
              }else if(toolbar[i]['toolbarType'] == 'edit'){
                toolbar[i]['handler'] = function () {
                  this.that.handleEditOpenDialog(toolbar[i]['relatePageId']);
                };
              }else if(toolbar[i]['toolbarType'] == 'delete'){
                let deleteServiceKey = toolbar[i]['dataServerKey1']
                toolbar[i]['handler'] = function () {
                  this.that.deleted(deleteServiceKey);
                };
              }
            }
            this.$nextTick(()=>{
              this.$refs.xrTable.getData();
            })
          }
        })
      },
      //刷新表格
      refreshTable(){
        this.$refs.xrTable.getData();
      },
      //打开【新增】的页面
      handleAddOpenDialog(relatePageId){
        this.isPageAddShow = true;
        this.$nextTick(()=>{
          this.$refs.pageAdd.init(relatePageId) //初始化页面
        })
      },
      //打开【修改】的页面
      handleEditOpenDialog(relatePageId){
        //获取选中id数组
        let list = this.$refs.xrTable.multipleSelection;
        //判断是否选中
        if(list.length !== 1){
          this.$message.warning("请选择一条数据")
          return false;
        }
        let id = list[0];
        this.isPageEditShow = true;
        this.$nextTick(()=>{
          this.$refs.pageEdit.init(relatePageId, id) //初始化页面
        })
      },
      //删除
      deleted(deleteServiceKey){
        let primaryKey = this.configure['primaryKey'];        //获取主键字段
        const list = this.$refs.xrTable.multipleSelectionItem;
        if (list.length < 1){
          this.$message.warning("请选择至少一条数据")
          return false;
        }
        const ids = this.CommonUtils.createStrByList(list, primaryKey);
        this.$confirm(`确定进行批量删除操作?`, '提示', {confirmButtonText: '确定', cancelButtonText: '取消',type: 'warning'}).then(() => {
          return this.request({
            method:'post',
            url:'/web/service',
            params:{
              'method': deleteServiceKey,
              'ids': ids
            }
          }).then((response) =>{
            if (response.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.$refs.xrTable.getData();
                }
              })
            } else {
              this.$message.error(response.msg)
            }
          })
        }).catch(() => {})
      },
      refreshData(){
        this.$refs.xrTable.getData();
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/template/NormalTable.vue